export const COMPLETED = "COMPLETED";
export const REVERTED = "REVERTED";

export const IMPACTS = {
  COMPLETED,
  REVERTED,
};
